import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-reject-confirmation',
    imports: [FormsModule, MatIconModule],
    templateUrl: './reject-confirmation.component.html',
    styleUrl: './reject-confirmation.component.css'
})
export class RejectConfirmationComponent {
  readonly dialogRef = inject(MatDialogRef<RejectConfirmationComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA, { optional: true });
  rejectReason = '';

  // Starting points, to be edited.
  readonly templates = [
    { label: 'Could not verify business', text: 'We were unable to verify your business from the details provided. If you can share a company registration number or a link to your trading website, we would be happy to look again.' },
    { label: 'Details incomplete', text: 'The information provided was incomplete, so we could not process your trade account request. Please re-apply with your full company details.' },
    { label: 'Not a trade customer', text: 'Unfortunately your application does not meet our trade account criteria at this time. You are welcome to continue ordering at our standard prices.' },
  ];

  useTemplate(text: string) {
    this.rejectReason = text;
  }

  onRejectClick() {
    this.dialogRef.close({ rejectReason: this.rejectReason.trim() });
  }

  onCancel() {
    this.dialogRef.close({ rejectReason: undefined });
  }
}
